export const facebookStatisticsGroups = [
  {
    label: '',
    options: [
      {value: 'source', label: 'Поток'},
      {value: 'campaign', label: 'Кампании'},
      {value: 'adset', label: 'Adset'},
      {value: 'ad', label: 'Ad'},
    ],
  },
];
